import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Dollar = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="dollar icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
    />
    <path
      className={pathClass}
      d="M7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12Z"
    />
    <path
      className={pathClass}
      d="M18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 19C24 20.1046 23.1046 21 22 21H2C0.89543 21 0 20.1046 0 19V5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V19ZM3 15V9C4.65685 9 6 7.65685 6 6H18C18 7.65685 19.3431 9 21 9V15C19.3431 15 18 16.3431 18 18H6C6 16.3431 4.65685 15 3 15Z"
    />
  </svg>
)
